import { AxiosResponse } from "axios";
import { axiosClient } from "../axiosClient";
import { axiosSafeRequest } from "../axiosSafeRequest";

/**
 * Remove (deactivate) a machine from the licence key.
 *
 * @param machineCode The Cryptolens machine code to deactivate.
 * @returns An HTTP response.
 */
export const apiMachineMachineDelete = async (machineCode: string): Promise<AxiosResponse | undefined> => {
  const url = `/machine/machines/${encodeURIComponent(machineCode)}`;
  const result = await axiosSafeRequest(() => axiosClient.delete(url));
  return result;
}
